import usePageTitle from "../utils/usePageTitle";
import React from "react";
import { Container } from "common-tailwind-components";
import { useTranslation } from "react-i18next";
import { startDemoTour } from "../components/tour/launch";

const SectionDemos = () => {
  const { t } = useTranslation();
  usePageTitle(t("tour.settings_title"));

  const demos = [
    { id: "procurement-demo", team: t("tour.demo_label"), useCase: "Cost management" },
    { id: "ap-exception-demo", team: t("tour.ap_label"), useCase: "Invoicing" },
    { id: "hr-keyperson-demo", team: t("tour.hr_label"), useCase: "Key-person risk" },
    { id: "cs-knowledge-demo", team: t("tour.cs_label"), useCase: "Knowledge gaps" },
  ];

  return (
    <Container>
      <div className="px-6 pb-16 pt-7">
        <div className="max-w-3xl">
          <h1 className="mb-8 text-2xl font-bold text-text">{t("tour.settings_help")}</h1>
          <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {demos.map(demo => (
              <li key={demo.id}>
                <button
                  type="button"
                  onClick={() => startDemoTour(demo.id)}
                  className="h-full w-full rounded-lg border border-outline bg-surface px-4 py-4 text-left transition hover:bg-muted-surface"
                >
                  <div className="font-medium text-text">{demo.team}</div>
                  <div className="text-xs text-muted">{demo.useCase}</div>
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Container>
  );
};

export default SectionDemos;
